import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { fetchBrandConfigModulesPack } from 'actions/Brands';

import GeneralInfo from './FormTabs/GeneralInfo/GeneralInfo';

const AddUserForm = () => {
  const { t } = useTranslation();
  const { selectedBrand } = useSelector(state => state.Auth);

  useEffect(() => {
    fetchBrandConfigModulesPack(selectedBrand, ['ConfigClientPanel']);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, []);

  return (
    <>
      <h2>{t('clients.clientCreation')}</h2>
      <GeneralInfo cancelPath="/admin/clients" />
    </>
  );
};

export default AddUserForm;
